angular.module('app').factory('PatientPortalStorageRepository',
    ['storage', '$timeout', 'LocalStorageRepository',
        function (storage, $timeout, LocalStorageRepository) {
            'use strict';

            function removeActivePatient() {
                storage.remove('activePatient');
            }

            function getActivePatient() {
                var activePatient = storage.get('activePatient');
                return {
                    id: activePatient && activePatient.id,
                    firstName: activePatient && activePatient.firstName,
                    lastName: activePatient && activePatient.lastName,
                    fullName: activePatient && activePatient.fullName,
                    isPatient: activePatient && activePatient.isPatient
                };
            }

            function setActivePatient(id, firstName, lastName, isPatient) {
                var activePatient = {
                    id: id,
                    fullName: firstName + ' ' + lastName,
                    firstName: firstName,
                    lastName: lastName,
                    isPatient: isPatient
                };

                storage.set('activePatient', activePatient);
            }

            function getResponsibleParties() {
                return storage.get('responsibleParties');
            }

            function setResponsibleParties(value) {
//                Array of AccountResponsiblePartyDto
//                [
//                    {"Id": "2ab0d13c-2bbe-46f5-990d-533067be2eb3",
//                        "Relationship": {
//                            "Id": "7b4c63c7-fe13-48ef-81e5-3afc963f3fee",
//                            "Name": "Self",
//                            "ExternalId": "18",
//                            "AnsiCode": "18"},
//                        "FirstName": "George",
//                        "LastName": "Cassidy",
//                        "FullName": "George Cassidy"}
//                ]
                storage.set('responsibleParties', value);
            }

            function getActiveResponsibleParty() {
                // _.find(responsibleParties, { IsPatient: true, IsActivePerson: true, IsActivePersonWeb: true });
                var responsibleParties = storage.get('responsibleParties');
                var activeResponsibleParty = _.find(responsibleParties, { IsPatient: true, IsActivePerson: true });
                return activeResponsibleParty;
            }

            function getActiveResponsibleParties() {
                var responsibleParties = storage.get('responsibleParties');
                var activeResponsibleParties = _.filter(responsibleParties, { IsPatient: true, IsActivePerson: true });
                return activeResponsibleParties;
            }


            function removeResponsibleParties() {
                storage.remove('responsibleParties');
            }

            function removeFeatureList(){
                storage.remove('featureList');
            }

            function getLoginUser() {
                return {
                    name: LocalStorageRepository.getUserName(),
                    fullName: LocalStorageRepository.getUserFullName(),
                    id: LocalStorageRepository.getUserID(),
                    token: LocalStorageRepository.getJsonWebToken(),
                    clientId: LocalStorageRepository.getClientID(),
                    clientURL: LocalStorageRepository.getClientURL(),
                    deviceId: LocalStorageRepository.getDeviceId(),
                    permissions: LocalStorageRepository.getUserPermissions(),
                    isPatient: LocalStorageRepository.getIsPatient()
                };
            }

            function getIsAccountResponsiblePartyForPatient() {
                return storage.get('isAccountResponsiblePartyForPatient');
            }

            function setIsAccountResponsiblePartyForPatient(value) {
                storage.set('isAccountResponsiblePartyForPatient', value);
            }

            return {
                getActivePatient: getActivePatient,
                setActivePatient: setActivePatient,
                removeActivePatient: removeActivePatient,
                getResponsibleParties: getResponsibleParties,
                setResponsibleParties: setResponsibleParties,
                removeResponsibleParties: removeResponsibleParties,
                getLoginUser: getLoginUser,
                getActiveResponsibleParty: getActiveResponsibleParty,
                getActiveResponsibleParties: getActiveResponsibleParties,
                removeFeatureList : removeFeatureList,
                getIsAccountResponsiblePartyForPatient: getIsAccountResponsiblePartyForPatient,
                setIsAccountResponsiblePartyForPatient: setIsAccountResponsiblePartyForPatient
            };
        }
    ]);
